export default __webpack_public_path__ + "static/media/5.f66ebd30.png";